import { createSingleEntityStore } from '@core/ngrx-legacy';

import type { LanguageListItem } from './language-list-http-client';
import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<LanguageListItem[]>()(
  EntityStoreKey.languageList,
);

const LanguageListActions = <Pick<typeof actions, 'fetch' | 'fetchSuccess' | 'fetchFailed'>>actions;

export {
  LanguageListActions,
  actions,
  reducer as LanguageListReducer,
  selectors as LanguageListSelectors,
  namespace as LanguageListNamespace,
};
